module.exports = __webpack_public_path__ + "static/009-36c1ffcb02ec4cb7fcf9ab6b23c0b7d4.png";